/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_GenerateInputs */

const en_read_along_ai_generate = /** @type {(inputs: Read_Along_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate insights`)
};

const es_read_along_ai_generate = /** @type {(inputs: Read_Along_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar información`)
};

/**
* | output |
* | --- |
* | "Generate insights" |
*
* @param {Read_Along_Ai_GenerateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_generate = /** @type {((inputs?: Read_Along_Ai_GenerateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_GenerateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_generate(inputs)
	return en_read_along_ai_generate(inputs)
});